"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  '16:9 Youtube': 169,
  '1:1 Facebook': 300,
  '4:5 Instagram': 375,
  '9:16 IGTV': 533
};
exports.default = _default;